import axios from "../../config/axiosConfig";
import { TAX_JV_REQUEST, TAX_JV_REQUEST_SUCCESS, TAX_JV_REQUEST_FAILURE } from "../types";


export const generateTaxJV = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: TAX_JV_REQUEST });
      return axios.post("/generate-tax-jv/all", {},
        {
            params: {
                userId: auth.user?.id,
                companyId: auth.company?.id,
                customerId: auth?.customer?.id,
                finyearId: auth?.finyear?.id
            }
        }).then((response) => {
            dispatch({ type: TAX_JV_REQUEST_SUCCESS });
            return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: TAX_JV_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: TAX_JV_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteAllTaxJV = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: TAX_JV_REQUEST });
      return axios.delete(`/generate-tax-jv/delete-all`,
        {
            params: {
                userId: auth.user?.id,
                companyId: auth.company?.id,
                customerId: auth?.customer?.id,
                finyearId: auth?.finyear?.id
            }
        }).then((response) => {
            dispatch({ type: TAX_JV_REQUEST_SUCCESS });
            return response;
        }).catch((error) => {
            console.error(error);
            dispatch({ type: TAX_JV_REQUEST_FAILURE, error: error.message });
            throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: TAX_JV_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
